/* eslint-disable react/sort-comp,camelcase */
import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import RequestDetailModal from '../../../travel-expense/detail/index';
import ConfirmModal from '../../../common/modal/confirm/index';
import InfoTooltip from '../../../common/tooltip/info/index';
import getCurrencySymbol from '../../../../constants/currencies';
import StatusView from '../../../StatusView';
import PDFDownload from '../../../travel-expense/pdf/index';
import {
  ACCOUNTING,
  COMPLETED,
  PENDING,
  REJECTED,
  WAITING_FOR_ACCOUNTING_CANCELLED,
  WAITING_FOR_CANCELLED
} from '../../../../constants/travelExpenseStatus';
import i18next from 'i18next';

const DeleteButton = open => (
  <InfoTooltip info={i18next.t('cancelTravelExpense')}>
    <button className="btn btn-xs btn-fill btn-danger" onClick={open}>
      <i
        className="fa fa-trash"
      />
    </button>
  </InfoTooltip>
);

const UpdateButton = ({ request }) => (
  <InfoTooltip info={i18next.t('editTravelExpense')}>
    <Link
      className="btn btn-default btn-xs btn-fill"
      to={`/edit-request/${request._id}`}
    >
      <i className="fa fa-edit" />
    </Link>
  </InfoTooltip>
);

class GeneralTableSubRow extends React.Component {
  constructor(props) {
    super(props);

    this.deleteButtonAction = this.deleteButtonAction.bind(this);
    this.getActionsView = this.getActionsView.bind(this);

    this.state = {
      subRequestShow: false,
      requestStatus: props.requestStatus
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ requestStatus: nextProps.requestStatus });
  }


  async deleteButtonAction() {
    const { deleteRequest, renderPage } = this.props.actionButtonEvents;
    const { request, group_id } = this.props;

    await deleteRequest(group_id, request._id);
    await renderPage();
  }

  getActionsView() {
    const { request, lastBusinessDayOfMonth } = this.props;
    const { confirmationDate } = request;

    let isEnableForEditing = false;
    const confirmationDateUnix = confirmationDate !== null ? moment(new Date(confirmationDate)).unix() : null;

    if (confirmationDate == null || parseInt(`${confirmationDateUnix}000`) <= parseInt(lastBusinessDayOfMonth)) {
      isEnableForEditing = true;
    }

    if (request.status === PENDING
      || request.status === ACCOUNTING
          || request.status === WAITING_FOR_CANCELLED
      || request.status === WAITING_FOR_ACCOUNTING_CANCELLED) {
      return (
        <div>
          <RequestDetailModal request={request} isManager={false} />
          <span>
&nbsp;
          </span>
            {(request.status !== WAITING_FOR_CANCELLED && request.status !== WAITING_FOR_ACCOUNTING_CANCELLED) && (
                    <ConfirmModal
                        title="Emin misiniz?"
                        trigger={DeleteButton}
                        confirm={this.deleteButtonAction}
                    >
                        <h3>Talebiniz İptal edilecek</h3>
                    </ConfirmModal>
            )}
            <span>
&nbsp;
          </span>
          <UpdateButton {...this.props} />
        </div>
      );
    }

    if (request.status === COMPLETED) {
      if (isEnableForEditing) {
        return (
            <div>
                <RequestDetailModal request={request}/>
                <span>
                &nbsp;
            </span>
                <UpdateButton {...this.props} />
                <span>
                &nbsp;
            </span>
                <PDFDownload request={request}/>
            </div>
        );
      }

        return (
            <div>
                <RequestDetailModal request={request}/>
                <span>
                &nbsp;
          </span>
                <PDFDownload request={request}/>
                <span>
                &nbsp;
            </span>
                <ConfirmModal
                    title="Emin misiniz?"
                    trigger={DeleteButton}
                    confirm={this.deleteButtonAction}
                >
                    <h3>
                        Talebiniz İptal
                        edilecek
                    </h3>
                </ConfirmModal>
            </div>
        );
    }

      if (request.status === REJECTED) {
          return (
              <div>
                  <RequestDetailModal request={request}/>
                  <span>
&nbsp;
          </span>
                  <UpdateButton {...this.props} />
              </div>
          );
      }

      return (
          <span>
Bilinmiyor
      </span>
      );
  }

    render() {
        const {request} = this.props;
        const {calculatedAmount} = request;

    return (
      <div className="row">
        <div className="col-md-1" />
        <div className="col-md-1">
          <span>
            <StatusView request={request} />
          </span>
        </div>
        <div className="col-md-2">
          <span>
            {moment(new Date(request.travelStartDate)).format('DD-MM-YYYY')}
            {' '}
            {request.travelStartHour}
          </span>
          <br />
          <span>
            {moment(new Date(request.travelEndDate)).format('DD-MM-YYYY')}
            {' '}
            {request.travelEndHour}
          </span>
        </div>
        <div className="col-md-2 ellipsis">
          <span>
            {request.travelReasons.map(
              reason => (
                <span key={reason.value}>
                  {reason.label}
                </span>
              ))}
          </span>
        </div>
        <div className="col-md-2 ellipsis">
          {
                  request.type === 'domestic'
                    ? (request.domestic.provinces.map(p => (
                      <span key={p.value}>
                        {' '}
                        {p.label}
                        {' '}
                      </span>
                    )))
                    : (
                      <span>
                        {request.abroad.country}
                      </span>
                    )
              }
        </div>
        <div className="col-md-1">
          <InfoTooltip info={i18next.t('travelExpenseGrossPayment')}>
            {
                  request && request.status === 'completed'
                    ? (
                      <span>
                        {calculatedAmount.amount}
                        {' '}
                        {getCurrencySymbol(
                          calculatedAmount.abroadCurrency)}
                      </span>
                    )
                    : <span />

              }

          </InfoTooltip>
        </div>
        <div className="col-md-1">
          <InfoTooltip info={i18next.t('individualAccommodationAmount')}>
            <span>
              {calculatedAmount.individualAccommodationAmount
                ? calculatedAmount.individualAccommodationAmount
                : 0}
              {' '}
              {getCurrencySymbol(calculatedAmount.abroadCurrency)}
            </span>
          </InfoTooltip>
        </div>
        <div className="col-md-2">aa
          {this.getActionsView()}
        </div>
      </div>
    );
  }
}

export default GeneralTableSubRow;



// WEBPACK FOOTER //
// ./src/components/user/table/sub-row/index.js